import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AppToggleSwitchComponent } from './app-toggle-switch.component';

@NgModule({
  declarations: [AppToggleSwitchComponent ],
  imports: [ CommonModule ],
  exports: [AppToggleSwitchComponent ],
  bootstrap: []})
export class AppToggleSwitchModule {}
